import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.00487f91.js","_app/immutable/chunks/scheduler.b6a01382.js","_app/immutable/chunks/index.a3f59a79.js","_app/immutable/chunks/Loading.b07dc5e3.js","_app/immutable/chunks/index.a2248096.js"];
export const stylesheets = ["_app/immutable/assets/2.2a4918a6.css","_app/immutable/assets/Loading.218e0f39.css"];
export const fonts = [];
